import { render, staticRenderFns } from "./BlockListPlaceholder.vue?vue&type=template&id=79c8277c&"
import script from "./BlockListPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BlockListPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./BlockListPlaceholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports